// removed by extract-text-webpack-plugin
module.exports = {"container":"src-styles----featured-post-module---container---2PCCg","content":"src-styles----featured-post-module---content---3dGRf","title":"src-styles----featured-post-module---title---3xkUO","player":"src-styles----featured-post-module---player---3Z8-8","image":"src-styles----featured-post-module---image---xdnQs","audio":"src-styles----featured-post-module---audio---2fAu5","shownotes":"src-styles----featured-post-module---shownotes---3mN_B","date":"src-styles----featured-post-module---date---3YWZP"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/featured-post.module.scss
// module id = 151
// module chunks = 35783957827783